export type ImmotionAuftragFields = {
  schadensdatum: string;
  mieter: string;
  wirtschaftseinheit: string;
  hauseingang: string;
  wohnung: string;
  gewerk: string;
  leistung: string;
  schadensbeschreibung: string;
  erfasser: string;
  isWohnungsmodernisierung: boolean;
};

export const EMPTY_IMMOTION_AUFTRAG_FIELDS: ImmotionAuftragFields = {
  schadensdatum: "",
  mieter: "",
  wirtschaftseinheit: "",
  hauseingang: "",
  wohnung: "",
  gewerk: "",
  leistung: "",
  schadensbeschreibung: "",
  erfasser: "",
  isWohnungsmodernisierung: false,
};
